import 'jquery';

export default class Accordion {
  constructor($el) {
    this.$el = $el;
    this.activeClass = 'is-accordion-open';
    this.animationTime = 250;

    if (!$(this.$el).hasClass(this.activeClass)) {
      $(this.$el).next().css('display', 'none');
    }
    this.accordionInit(this.$el);
  }
  accordionClick(element) {
    $(element)
      .off('click')
      .on('click', (e) => {
        e.preventDefault();

        if ($(e.currentTarget).hasClass(this.activeClass)) {
          $(e.currentTarget).removeClass(this.activeClass);
          $(e.currentTarget).next().slideUp(this.animationTime);
        } else {
          // should siblings close?
          if ($(element).attr('data-close-others')) {
            this.accordionCloseOthers(element);
          }
          // add active class and show accordion
          $(e.currentTarget).addClass(this.activeClass);
          $(e.currentTarget).next().slideDown(this.animationTime);
        }
      });
  }

  accordionCloseOthers(element) {
    const elementsToClose = $(element)
      .parent()
      .parent()
      .find($('[data-close-others="true"]'));

    elementsToClose.removeClass(this.activeClass);
    elementsToClose.next().slideUp(this.animationTime);
  }
  accordionInit(element) {
    this.accordionClick(element);
  }
}